/**
 * Kdo smí vidět maturitní obsah a doučování.
 *
 * AIDEV-NOTE: Jediné místo, kde se tohle rozhoduje — čte to menu i guardy v routách.
 * Pořadí podmínek je závazné: **nejdřív ročník, pak balíček.** Obráceně by páťák
 * spadl do větve "upgrade" a aplikace by mu nabídla dokoupit Kompletní kurz.
 * `fullAccess` je volitelný schválně: Zóna ho posílá jen u maturantů a starší
 * dokumenty ho nemají, takže chybějící hodnota znamená plný přístup, nikdy zámek.
 * [TD-351]
 */
export type ContentAccess = "granted" | "upgrade" | "hidden";

/** Hodnota `User.Grade.HIGH_SCHOOL_GRADUATE` z todas-app (`firestore/model/user.py:27`). */
const HIGH_SCHOOL_GRADUATE = "maturant";

export const graduationContentAccess = (
  grade: string | null | undefined,
  fullAccess: boolean | null | undefined,
): ContentAccess => {
  if (grade !== HIGH_SCHOOL_GRADUATE) return "hidden";
  if (fullAccess === false) return "upgrade";

  return "granted";
};

export const isTutoringVisible = (grade: string | null | undefined): boolean => grade !== HIGH_SCHOOL_GRADUATE;
